const religiousHistory = [
  { label: "Muslim since birth", value: "Muslim since birth" },
  {
    label: "Considering to become a Muslim",
    value: "Considering to become a Muslim",
  },
  { label: "Revert", value: "Revert" },
];
export default religiousHistory;
